export const postMockServerRequest = async (
	url: string,
	body: unknown
): Promise<Response> => {
	const response = await fetch(url, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});

	if (!response.ok) {
		const responseBody = await response.text();
		throw new Error(
			`Mock server returned ${response.status}: ${responseBody}`
		);
	}

	return response;
};